import { render, staticRenderFns } from "./Suppliers.vue?vue&type=template&id=e0a3ca44&scoped=true&"
import script from "./Suppliers.vue?vue&type=script&lang=ts&"
export * from "./Suppliers.vue?vue&type=script&lang=ts&"
import style0 from "./Suppliers.vue?vue&type=style&index=0&id=e0a3ca44&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a3ca44",
  null
  
)

export default component.exports